module.exports = __webpack_public_path__ + "img/honey-splash.c3efa6a6.png";